import { AI_API_ENDPOINT, ACTION_TYPES } from '../constants';

/**
 * Service for handling API calls to the AI backend
 */
const aiService = {
  /**
   * Process text with AI
   * @param {string} action - The action to perform (improve, fix_grammar, etc.)
   * @param {string} text - The text to process
   * @param {string} context - Optional context information
   * @param {string} lengthPreference - Optional length preference
   * @returns {Promise<Object>} - Promise with the API response
   */
  async processText(action, text, context = '', lengthPreference = '') {
    if (!text || text.trim() === '') {
      throw new Error('No text provided');
    }

    const payload = encodeURIComponent(text);
    let url = `${AI_API_ENDPOINT}?action=${action}&text=${payload}`;
    
    // Add context parameter if provided
    if (context && context.trim() !== '') {
      const encodedContext = encodeURIComponent(context);
      url += `&context=${encodedContext}`;
    }
    
    // Add length preference parameter if provided
    if (lengthPreference && lengthPreference.trim() !== '') {
      const encodedLengthPreference = encodeURIComponent(lengthPreference);
      url += `&length_preference=${encodedLengthPreference}`;
    }

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`API request failed with status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('AI API error:', error);
      throw error;
    }
  },

  /**
   * Ask a question to the AI
   * @param {string} query - The question to ask
   * @param {string} selectedText - The selected text for context
   * @param {string} context - Optional context information
   * @returns {Promise<Object>} - Promise with the API response
   */
  async askQuestion(query, selectedText = '', context = '') {
    if (!query || query.trim() === '') {
      throw new Error('No query provided');
    }

    // Combine the question with the selected text for better context
    let fullText = query;
    if (selectedText && selectedText.trim() !== '') {
      fullText = `Pregunta: ${query}\n\nTexto seleccionado: "${selectedText}"`;
    }

    const payload = encodeURIComponent(fullText);
    let url = `${AI_API_ENDPOINT}?action=${ACTION_TYPES.ASK}&text=${payload}`;
    
    // Add context parameter if provided
    if (context && context.trim() !== '') {
      const encodedContext = encodeURIComponent(context);
      url += `&context=${encodedContext}`;
    }

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`API request failed with status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('AI ask error:', error);
      throw error;
    }
  }
};

export default aiService;
